// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text, ThemeIcon } from '@mantine/core';
import { FC } from 'react';
import { IconBrandGmail, IconCheck, IconX } from '@tabler/icons';
import { GoogleAccountDTO } from '../../../Types/GoogleT';
import GrayBox, { GrayBoxV2 } from '../../../Atoms/GrayBox';
import GoogleScopeIcon from './GoogleScopeIcon';
import ConfigOption from './ConfigOption';

const GoogleGmailPane: FC<{ googleAccount: GoogleAccountDTO }> = ({ googleAccount }) => {
  const { hasSendMailScope } = googleAccount;

  return (
    <GrayBoxV2
      rightSection={<GoogleScopeIcon accessGranted={hasSendMailScope} innerIcon={<IconBrandGmail size={14} />} />}
    >
      <Text size="lg" mb="xl">
        Gmail
      </Text>
      <ConfigOption
        title="Mail senden"
        description="bookitup kann in Ihrem Namen eine E-Mail senden"
        rightSection={
          <ThemeIcon radius="xl" size="sm" color={hasSendMailScope ? 'blue' : 'red'}>
            {hasSendMailScope ? <IconCheck size={14} /> : <IconX size={14} />}
          </ThemeIcon>
        }
      />
    </GrayBoxV2>
  );
};

export default GoogleGmailPane;
